import React from 'react';

import CountBadge from './count-badge';
import NewBadge from './new-badge';

type NavBadgesProps = {
  type: 'collapsed' | 'expanded';
  itemKey: string;
  count: number;
  hasVisitedAgencyPortal: boolean;
  showInfoOnDemo?: boolean;
  shouldShowSidebarInfo?: boolean;
  missedCallCount?: number;
};

const NavBadges: React.FC<NavBadgesProps> = ({
  type,
  itemKey,
  shouldShowSidebarInfo,
  showInfoOnDemo,
  count,
  hasVisitedAgencyPortal,
  missedCallCount,
}) => {
  const renderBadges = (key: string, className = 'default') => {
    if (shouldShowSidebarInfo && showInfoOnDemo) {
      return <></>;
    }

    const shouldShowCountBadge = key === 'unifiedInbox' && count > 0;
    const targetKey = type === 'expanded' ? 'call-logs' : 'dialer';

    const shouldShowCallLogsCountBadge =
      key === targetKey && missedCallCount > 0;
    const shouldShowBadgeForAgencyPortal =
      key === 'agencyPortal' && !hasVisitedAgencyPortal;

    const shouldShowNewBadge = ['dialer']?.includes(key);

    return (
      <>
        {shouldShowCountBadge && (
          <CountBadge count={count} className={className} />
        )}
        {shouldShowCallLogsCountBadge && (
          <CountBadge
            count={missedCallCount}
            className={`call-logs-count-badge ${
              missedCallCount > 99 ? 'lg' : ''
            } ${className}`}
          />
        )}
        {shouldShowNewBadge && missedCallCount === 0 && (
          <NewBadge
            className={`${className} ${
              key === 'dialer' ? 'call-logs-new-badge' : ''
            }`}
          />
        )}
        {shouldShowBadgeForAgencyPortal && (
          <div className={`app-sidebar__dot-badge ${className}`} />
        )}
      </>
    );
  };

  if (type === 'expanded') {
    return (
      <div className="app-sidebar__badges expanded">
        {renderBadges(itemKey, 'expanded')}
      </div>
    );
  }

  return <div className="app-sidebar__badges">{renderBadges(itemKey)}</div>;
};

export default NavBadges;
